import branchManagementItemHoldsComponent from './item_holds.component';

let branchManagementItemHoldsModule = angular.module('branchManagementItemHolds', [])
  .component('branchManagementItemHolds', branchManagementItemHoldsComponent)
  .name;

export default branchManagementItemHoldsModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/item_holds/index.js